import { useMemo } from 'react';
import { z } from 'zod';
import { STATE_SCHEMA } from '@/utils/helpers';
import { useCountriesData } from '@/contexts/CountriesDataProvider';
import { NameByValue } from '@/types';
import { NewOpoForm } from './types';
import { createOpoFormValidation } from './utils';

export const DEFAULT_OPO_VALUES: NewOpoForm = {
  name: '',
  code: '',
  timezone: '',
  timezoneIANA: '',
  addressId: '',
  addressLine: '',
  city: '',
  state: null,
  postalCode: '',
  country: '',
  longitude: 0,
  latitude: 0,
};

export const opoSchema = z.object({
  name: z.string().min(1, 'Provide opo name'),
  code: z.string().min(1, 'Provide opo code'),
  timezone: z.string(),
  timezoneIANA: z.string(),
  addressId: z.string().optional(),
  addressLine: z.string().min(1, 'Provide opo address'),
  city: z.string().min(1, 'Provide opo city'),
  state: STATE_SCHEMA,
  postalCode: z.string().min(1, 'Provide opo postal code'),
  country: z.string(),
  latitude: z.number().min(-90).max(90).nullable(),
  longitude: z.number().min(-180).max(180).nullable(),
  primaryContactId: z.string().optional(),
});

export const opoFormEditSchema = (composedSubdivisionsList: Record<string, NameByValue[]>) =>
  opoSchema.superRefine(createOpoFormValidation(composedSubdivisionsList));

export const opoFormCreateSchema = (composedSubdivisionsList: Record<string, NameByValue[]>) =>
  opoSchema.superRefine(createOpoFormValidation(composedSubdivisionsList));

export const useOpoFormEditSchema = () => {
  const { composedSubdivisionsList, isLoading } = useCountriesData();
  const schema = useMemo(() => opoFormEditSchema(composedSubdivisionsList), [composedSubdivisionsList]);
  return { schema, isLoading };
};

export const useOpoFormCreateSchema = () => {
  const { composedSubdivisionsList, isLoading } = useCountriesData();
  const schema = useMemo(() => opoFormCreateSchema(composedSubdivisionsList), [composedSubdivisionsList]);
  return { schema, isLoading };
};
